import React from "react";
import "./blogs.css";

const Sandipan_Mitra = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src="placement-postulates/blogs/Sandipan-Mitra/dp.jpg"
            style={{ height: "315px", width: "90%" }}
            alt="sandipan"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Sandipan Mitra</h2>
            <small>Analyst, Auronova Consulting</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Introduction:</h2>
            <p>
              Hey everyone! I am Sandipan Mitra (Y19, CE), and I got an offer
              from Auronova Consulting in the Analyst profile on Day 2 of the
              Placement season 2022-23. My preparation journey isn’t remarkably
              different from most people who sat for placements, but I believe
              every person’s journey has unique takeaways worth sharing. I was
              (and still am :p) an indecisive kid who didn’t know which career
              to pursue. I know many people who had their goals set from their
              first year, and I was not one of them. In my first year, I was
              thinking about an MBA later, so I avoided most of the technical
              stuff. Although later on, I surrendered to the rat race of coding
              and started preparing for the same before the internship season,
              mostly because maximum companies required a coding test for an
              interview shortlist, and also, being from Civil there were
              limitations on the available opportunities. Since this is a
              placement blog, I won’t elaborate much on my internship
              experience. I secured an on-campus intern offer from Truminds in
              the SDE role. My work was in the backend team, and by the end of
              the internship, I felt I wasn’t suited for an SDE role. I
              eventually rejected their PPO and decided to sit for the
              placements. I was open to all profiles except APM roles since I
              was too lazy to prepare an attractive deck. I lost out on a
              Level-1 PoR, which hurt my chances for a ‘top-tier’ consulting
              shortlist.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Expectations:</h2>
            <p>
              I felt my resume was decent enough for a Day 1 offer, seeing last
              year's placements. And this is where I made a mistake. I kept a
              lot of expectations from myself when the job market was going for
              the worse. I was so overconfident that I stopped giving tests for
              Day 4 and further companies, believing that I would anyways get an
              offer before that and, if not, the walk-ins would anyways begin by
              then. (I will return to this topic again later)
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Sandipan-Mitra/1.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Coding Preparation:</h2>
            <p>
              I still kept applying for SDE roles (for safety), and most of the
              test questions were of hard or medium-level difficulty.
              Fortunately, I had practiced some of those questions earlier on
              Leetcode, so I was able to figure out their pattern. By the end, I
              noticed most of these companies almost directly or somewhat
              modified the questions from Leetcode, so I suggest the students
              preparing for SDE roles practice questions on Leetcode diligently.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Consulting:</h2>
            <p>
              Some consulting companies like Indus Insights, Auronova
              Consulting, Trinity Life Sciences and Finmechanics had screening
              tests, while most of the others like MBB (McKinsey, Bain, BCG),
              Alvarez and Marsal, and Arthur D Little directly shortlisted
              students for interviews via their resumes. Few had other selection
              strategies like Eversana first shortlisting via resume and then
              asking us to prepare a video based on specific prompts.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Analytical Profiles and Guesstimates:</h2>
            <p>
              Competition for analytics profiles was very tough, and one could
              get an interview shortlist only by attempting all questions
              correctly. I didn’t have great luck in this zone, as I somehow
              ended up missing one or two questions. Nomura shortlisted around
              45 for a Group Discussion round, where I struggled to get the
              momentum going and hence got rejected from an interview shortlist.
              Some companies had bogus shortlists for their tests, and it is
              entirely okay not to get a shortlist from them as, like you, many
              other people will remain scratching their heads on how even the
              shortlist was prepared!
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Importance of CPI:</h2>
            <p>
              Having an 8+ CPI was helpful for me in not facing problems in CPI
              screening of most companies. Many companies kept their CPI cutoff
              to 7.5 or 8; some high-paying quant firms required an 8+ CPI. No
              wonder I believe working on your CPI is the most important thing
              before your placements begin because it hurts when you have the
              required skills and get rejected only because of your CPI.
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          src="placement-postulates/blogs/Sandipan-Mitra/4.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Interview Experiences:</h2>
            <p>
              By the end of the tests, I had 7 interview shortlists; 5 from
              consulting firms - Alvarez and Marsal, Finmechanics, Indus
              Insights, Eversana, and Auronova Consulting, and 2 from SDE roles-
              Jaguar Land Rover (JLR) and Pine Labs. The general advice that I
              got from most seniors was to prepare for either of the 2 profiles
              and not for 2 profiles simultaneously - sailing two boats
              simultaneously would prove very dangerous. Plus, the preparation
              for SDE and consulting roles were poles apart - one was a
              technical role while the other was a non-technical one. By then, I
              had not coded for nearly a month, so I decided to focus solely on
              the consulting profile. I considered myself strong in guesstimates
              and weak in case studies, and so I prepared cases from the “IITB
              Case Interviews Cracked”, “IIMA Casebook”, and “Case Compendium-by
              an SRCC alum” with a few of my friends. Although later, I realized
              the practice was too little, and I should have practiced much more
              and much earlier. There was a buddy round from Indus Insights and
              a case workshop from Alvarez and Marsal (A&M) for the shortlisted
              students, giving a trailer of what was expected in the interviews.
              I prepared my resume well in the last two days, covering every
              point in detail. The one important thing I missed out on was
              appearing for mock interviews, and it had been over a year since I
              last appeared for a corporate interview. I would suggest students
              practice giving mock interviews, preferably conducted by seniors
              or friends who are not sitting for placements; it will help you
              assess your preparation well and your spontaneity.
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>D-Day Experiences:</h2>
            <p>
              Finally, the D-Day came. My experiences in the following slots
              were as follows:
              <br />
              <strong>DAY1.1:</strong> I had A&M and Finmechanics. There was a
              priority order of students for the interviews in A&M, and I had a
              low priority order in that, so I went for the Finmechanics
              interview first. The interview was mostly resume-based, with some
              standard mathematical puzzles (which could be found in GFG and
              Brainstellar). There were a few statistics-based questions in
              which I fumbled, which I believed ended my chances of going for
              the 2nd round of the same. As for A&M, they concluded their
              interviews and final selects even before I could get a chance to
              get interviewed, so that didn’t make way for a good night for me.
              <br />
              <strong>DAY1.2:</strong> I had Indus Insights scheduled, and the
              first round was on guesstimates. I was so overconfident in my
              ability in guesstimates that I didn’t practice for the same in the
              last 4-5 days. Guess what? I messed up on a slightly tricky
              question. It wasn’t the toughest guesstimate, but since I was out
              of practice, I missed certain key points to be noted while
              arriving at a particular solution. I expectedly didn’t get a call
              for the next round. I also had a waitlist in American Express, but
              they decided not to extend beyond the main shortlist this time,
              unlike last year.
              <br />
              <strong>DAY 2.1:</strong> Now I was getting anxious and restless.
              I fancied my chances for a Day 1 offer, but it wasn’t to be, and
              the next interview was in JLR for the SDE profile. I had not done
              coding for the past 20-25 days, so I thought this was a dead end.
              Yet I decided to revise a few pseudo codes and sorting algorithms.
              They asked a Leetcode-easy question, and I was somehow able to
              produce a solution and get it running successfully (Yes, they
              asked me to code it properly in some IDE). However, even after
              getting a hint, I fumbled to optimize it further. They further
              asked some HR-based and OOPS questions, which I answered properly,
              but the deal was closed on my earlier fumble. I got a call from
              the Media.Net PoCs, saying they didn’t select anyone from the main
              shortlist and thus invited the waitlisted students too, but on
              realizing they asked the toughest ever problems on coding to all
              those students, I didn’t dare to attend the same. I won’t suggest
              anybody skip an interview; just that at that moment, I didn’t have
              the required skills and mindset for the same, which made me do so.
              <br />
              <strong>DAY 2.2:</strong> It was my last slot of shortlists, and I
              had 3 - Eversana, Auronova, and Pine Labs. There were signs of
              giving up from my side, and I even thought of running back home if
              I didn’t get an offer today! I attended the Eversana interview
              first. The interviewer asked initially why I was interested in
              joining a pharmaceutical company, and I realized in horror I
              didn’t read at all about the company. I just came to the interview
              center on the spot, and this wasn’t the best decision in the most
              important phase of my life. Important lesson-read the JD(Job
              Description) thoroughly along with having some background of the
              company! I somehow concatenated an answer, but I don’t think he
              was impressed with it. The next question was a guesstimate, but he
              didn’t like my approach for the same. He explained a different
              approach, and I still don’t know what was wrong with my approach.
              . Immediately after that, I had my Auronova interview. Thankfully,
              the panelists didn’t ask me “Why Auronava?” and all sorts of
              questions about what the company does because back then, I had
              absolutely no clue. Since most of my projects were based on
              statistics, they asked me about the key concepts and their
              applications and how those were relevant to my project. After
              that, they asked 3-4 puzzles, which were again pretty standard
              that could be found in GFG. There were some other situation-based
              questions, and I think I did well in those. Almost immediately
              after the interview, the PoC informed me that they had extended me
              an offer.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Sandipan-Mitra/2.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Lessons Learned:</h2>
            <p>
              It wasn’t the smoothest end to my placement journey, but I’m glad
              it didn’t extend that long. More than my belief, my overconfidence
              made me skip tests of Day 3-4 and beyond companies, thinking that
              I could somehow get a chance in the walk-ins. That almost was a
              catastrophic decision as, this time, the walk-ins properly started
              after Day-5, and even they allowed fewer students to attend the
              interviews, and I didn’t have any shortlist post-Day 2. Maybe that
              should go down as a lesson to the upcoming batches sitting for
              placements, never to take opportunities for granted and be
              prepared for the worst. The SPO team was very supportive, and I am
              grateful for their efforts.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Helpful Resources:</h2>
            <p>
              I believe there have been many blogs and posts by seniors
              regarding what resources to be followed, although like to share a
              few resources that personally helped me in my preparation:
              <ul>
                <li>
                  <strong>SDE:</strong> Leetcode
                </li>
                <li>
                  <strong>Consulting:</strong> IITB Case Interviews Cracked,
                  IIMA Casebook, Case Compendium by an SRCC alum
                </li>
                <li>
                  <strong>Quant/ Puzzles/Probability:</strong> GFG,
                  Brainstellar, Gurmeet’s Puzzles, 50 Challenging Problems of
                  Probability, Xinfeng Zhou- a practical guide to quantitative
                  finance
                </li>
                <li>
                  <strong>Aptitude:</strong> Previous years' CAT papers
                </li>
                <li>
                  <strong>SQL:</strong> W3Schools, InterviewBit
                </li>
                <li>
                  <strong>OOPS:</strong> W3Schools
                </li>
              </ul>
              I had prepared docs on important points and topics that should be
              covered before interviews for different profiles and HR, and I
              hope some of you find them useful.
              <br />
              <ul>
                <li>
                  <b>Software:</b>{" "}
                  <a href="https://docs.google.com/document/d/1iby03eXhJB0kRK0BOAxKN7EQnU-NYrtmbQf-CzDUHMo/edit">
                    Link
                  </a>
                </li>
                <li>
                  <b>Machine learning, Statistics, SQL:</b>{" "}
                  <a href="https://docs.google.com/document/d/1f8u6aGFWEWcYSzW-gD7ag4pNsQYf9F7zaJIOjDolxrg/edit">
                    Link
                  </a>
                </li>
                <li>
                  <b>HR and other extracurricular points:</b>{" "}
                  <a href="https://docs.google.com/document/d/1yb5f-WXXi7XDIYVHDnNHUb7qHg2Mzl_xeV4T2pdlYkg/edit">
                    Link
                  </a>
                </li>
              </ul>
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          src="placement-postulates/blogs/Sandipan-Mitra/3.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Resume Preparation:</h2>
            <p>
              Goes without saying: prepare your resume thoroughly, covering
              every single word that you mentioned. Get your resume reviewed by
              multiple seniors before preparing a final draft. Having some
              knowledge of SQL and OOPS is very handy, as certain analytics or
              data-profile companies ask SQL queries, and software companies
              sometimes give you an edge if you have a decent knowledge of OOPS
              in their tests or interviews.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h2>Conclusion:</h2>
            <p>
              Be confident during interviews. It’s okay not to know the answer
              to a few questions; they don’t expect you to answer 100% of the
              questions. An analogy for the same could be- it’s not necessary to
              score 100% in a course in order to obtain an A grade; you can get
              the same with 75-80% marks. Similarly, you can convert an offer by
              answering 75-80% of the question, but be confident and calm in
              answering those questions-sometimes they deliberately ask tough
              questions to gauge your spontaneity or ability to handle pressure
              situations. Feel free to contact me for any queries, and all the
              best for your placements!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sandipan_Mitra;
